var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 10,
    fill: "#F6F7F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1048_3872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4983 40.5016C16.2568 35.2602 16.2568 26.7395 21.4983 21.4981C26.7397 16.2567 35.2603 16.2567 40.5017 21.4981C45.7432 26.7395 45.7432 35.2602 40.5017 40.5016C35.2603 45.743 26.7397 45.743 21.4983 40.5016ZM39.1759 22.8239C34.6681 18.3161 27.3319 18.3161 22.8241 22.8239C18.3163 27.3317 18.3163 34.6679 22.8241 39.1758C27.3319 43.6836 34.6681 43.6836 39.1759 39.1758C43.6837 34.6679 43.6837 27.3317 39.1759 22.8239Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.873 35.1982L26.8019 28.1272C26.4395 27.7648 26.4395 27.1637 26.8019 26.8013C27.1643 26.4389 27.7654 26.4389 28.1278 26.8013L35.1988 33.8724C35.5612 34.2348 35.5612 34.8358 35.1988 35.1982C34.8364 35.5606 34.2354 35.5606 33.873 35.1982Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8012 35.1982C26.4388 34.8358 26.4388 34.2348 26.8012 33.8724L33.8722 26.8013C34.2346 26.4389 34.8357 26.4389 35.1981 26.8013C35.5605 27.1637 35.5605 27.7648 35.1981 28.1272L28.127 35.1982C27.7646 35.5606 27.1636 35.5606 26.8012 35.1982Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1048_3872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(31 9.78662) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.7e15895d2c52390ee485dbdce1e74a30.svg";
export { ForwardRef as ReactComponent };